// ─── INKY TEXTILES QUOTE CALCULATOR ─────────────────────────────────────────

// ─── BRAND / GARMENT PRICING ─────────────────────────────────────────────────
// S&S Activewear public pricing × 1.60 (60% markup — garment cost + shipping).
// Gildan 5000: $6.22 × 1.6 = $9.95 | Bella+Canvas 3001: $8.98 × 1.6 = $14.37
// Inky Textiles Brand (Premium): fixed internal rate.
const BRAND_PRICES = {
  'gildan':      9.95,
  'bellacanvas': 14.37,
  'inky':        9.00,
};

// ─── SCREEN PRINTING COST TABLE ──────────────────────────────────────────────
// Source: Inky Textiles Screen Print Pricing 2024.
// Cost per piece per placement — does NOT include garment.
// Format: [min qty, 1-color, 2-color, 3-color, 4-color, 5-color, 6-color]
const SCREEN_PRINT_TABLE = [
  [12,  4.00, 5.00, 6.00, 7.00, 8.00, 9.00],   // qty 12-23
  [24,  3.00, 3.50, 4.00, 4.50, 5.00, 5.50],   // qty 24-47
  [48,  2.75, 2.95, 3.15, 3.35, 3.55, 3.75],   // qty 48-99
  [100, 2.35, 2.55, 2.75, 2.95, 3.15, 3.35],   // qty 100-299
  [300, 2.00, 2.20, 2.40, 2.60, 2.80, 3.00],   // qty 300+
];

// PRINT_MARKUP: markup on actual print cost baked into customer price.
// 1.50 = 50% markup → competitive with mid-market (CustomInk, RushOrderTees range).
// Adjust here only — does not affect garment markup above.
const PRINT_MARKUP = 1.50;

// Returns customer-facing print cost per piece per placement (base × markup).
function getScreenPrintCost(qty, colors) {
  const c = Math.min(Math.max(parseInt(colors) || 1, 1), 6);
  let row = SCREEN_PRINT_TABLE[0];
  for (let i = 0; i < SCREEN_PRINT_TABLE.length; i++) {
    if (qty >= SCREEN_PRINT_TABLE[i][0]) row = SCREEN_PRINT_TABLE[i];
  }
  return row[c] * PRINT_MARKUP;
}

// ─── PROMO CODES ─────────────────────────────────────────────────────────────
const PROMO_CODES = {
  'INKY10':  0.10,
  'GROUP15': 0.15,
  'WELCOME': 0.10,
};

// ─── SHIPPING ESTIMATE ────────────────────────────────────────────────────────
function getZipShipping(z) {
  if (!z || z.length < 5) return null;
  const d = parseInt(z[0]);
  if (d <= 3) return '$8\u2013$14';
  if (d <= 5) return '$6\u2013$11';
  if (d <= 7) return '$7\u2013$13';
  return '$9\u2013$16';
}

// ─── PLACEMENT HELPERS ───────────────────────────────────────────────────────
function togglePlacement(loc) {
  const chk    = document.getElementById('chk-' + loc);
  const block  = document.getElementById('pb-'  + loc);
  const sizes  = document.getElementById(loc + '-sizes');
  const presets= document.getElementById(loc + '-presets');
  if (!chk || !block) return;
  if (chk.checked) {
    block.style.opacity = '1';
    if (sizes)   sizes.style.display   = 'grid';
    if (presets) presets.style.display = 'flex';
  } else {
    block.style.opacity = '.45';
    if (sizes)   sizes.style.display   = 'none';
    if (presets) presets.style.display = 'none';
  }
  calcPrice();
}

function setSize(loc, w, h) {
  const wEl = document.getElementById(loc + '-w');
  const hEl = document.getElementById(loc + '-h');
  if (wEl) wEl.value = w;
  if (hEl) hEl.value = h;
  calcPrice();
}

function updateQty(val) {
  const d = document.getElementById('qty-display');
  if (d) d.textContent = parseInt(val).toLocaleString() + ' pieces';
}

// ─── MAIN PRICE CALCULATOR ───────────────────────────────────────────────────
function calcPrice() {
  const brandEl  = document.getElementById('brand');
  const qtyEl    = document.getElementById('qty');
  const colorsEl = document.getElementById('colors');
  const zipEl    = document.getElementById('zipcode');
  const promoEl  = document.getElementById('promo-code');
  if (!qtyEl) return;

  const brandKey     = brandEl    ? brandEl.value             : 'gildan';
  const garmentPrice = BRAND_PRICES[brandKey] || 9.95;
  const qty          = parseInt(qtyEl.value)  || 12;
  const colors       = colorsEl  ? parseInt(colorsEl.value)  : 3;
  const zip          = zipEl     ? zipEl.value               : '';
  const promo        = promoEl   ? promoEl.value.trim().toUpperCase() : '';

  // ── Count active placements ──
  const nP = (document.getElementById('chk-front')?.checked      ? 1 : 0)
           + (document.getElementById('chk-back')?.checked       ? 1 : 0)
           + (document.getElementById('chk-sleeve')?.checked     ? 1 : 0)
           + (document.getElementById('chk-leftchest')?.checked  ? 1 : 0)
           + (document.getElementById('chk-rightchest')?.checked ? 1 : 0);

  // ── Core calculation ──
  // Garment: brand price (already includes 60% markup over wholesale)
  const garmentTotal = garmentPrice * qty;

  // Print: real pricing table × 50% markup, per piece per placement
  const printPerPiecePlacement = getScreenPrintCost(qty, colors);
  const printTotal             = printPerPiecePlacement * nP * qty;

  let subtotal = garmentTotal + printTotal;

  // ── Promo code ──
  const promoValid = promo.length > 0 && PROMO_CODES[promo] !== undefined;
  let promoDiscount = 0;
  if (promoValid) {
    promoDiscount = subtotal * PROMO_CODES[promo];
    subtotal     -= promoDiscount;
  }

  // ── Promo display ──
  const promoDisplay = document.getElementById('promo-display');
  const promoNote    = document.getElementById('promo-note-text');
  if (promoDisplay) {
    if (!promo) {
      promoDisplay.textContent = 'Enter a promo code for a discount';
      promoDisplay.style.color = 'var(--gray)';
      if (promoNote) promoNote.textContent = 'Discount will be reflected in your quote total';
    } else if (promoValid) {
      const pct = Math.round(PROMO_CODES[promo] * 100);
      promoDisplay.textContent = pct + '% off applied \u2014 saving $' + promoDiscount.toFixed(2);
      promoDisplay.style.color = 'var(--egypt)';
      if (promoNote) promoNote.textContent = 'Code "' + promo + '" is valid \u00b7 discount included in total below';
    } else {
      promoDisplay.textContent = 'Code not recognized \u2014 double-check and try again';
      promoDisplay.style.color = '#e05252';
      if (promoNote) promoNote.textContent = '';
    }
  }

  // ── Shipping ──
  const ship = getZipShipping(zip);
  const sd = document.getElementById('shipping-display');
  const zn = document.getElementById('zip-note');
  if (sd) {
    if (ship) {
      sd.textContent = ship + ' est.';
      sd.style.color = 'var(--egypt)';
      if (zn) zn.textContent = 'Shipping to zip ' + zip + ' \u2014 final rate at checkout';
    } else {
      sd.textContent = 'Enter zip code for shipping estimate';
      sd.style.color = 'var(--gray)';
      if (zn) zn.textContent = 'Enter your zip code for an accurate shipping estimate';
    }
  }

  // ── Output ──
  const unit  = qty > 0 ? subtotal / qty : 0;
  const total = Math.round(subtotal);
  const upEl  = document.getElementById('unit-price');
  const tpEl  = document.getElementById('total-price');
  if (upEl) upEl.textContent = '$' + unit.toFixed(2);
  if (tpEl) tpEl.textContent = '$' + total.toLocaleString();

  // ── Breakdown label ──
  const pls = [];
  ['front','back','sleeve','leftchest','rightchest'].forEach(function(loc) {
    if (document.getElementById('chk-' + loc)?.checked) {
      const w = document.getElementById(loc + '-w')?.value;
      const h = document.getElementById(loc + '-h')?.value;
      const label = loc === 'leftchest' ? 'L.chest' : loc === 'rightchest' ? 'R.chest' : loc;
      if (w && h) pls.push(label + ' ' + w + '\u00d7' + h + '"');
    }
  });

  const bd = document.getElementById('price-breakdown');
  if (bd) {
    const printLine = nP > 0
      ? ' \u00b7 print $' + (printTotal / qty).toFixed(2) + '/shirt'
      : '';
    bd.textContent = qty + ' pcs'
      + (pls.length ? ' \u00b7 ' + pls.join(' \u00b7 ') : ' \u00b7 no placements')
      + printLine
      + (ship ? ' \u00b7 ship ' + ship : ' \u00b7 + shipping')
      + (promoValid ? ' \u00b7 ' + Math.round(PROMO_CODES[promo] * 100) + '% off' : '');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('qty')) { updateQty(48); calcPrice(); }
});
